import {
  BO_COOKIE_LIST,
  BO_COOKIE_SERVICE_NAME_LIST,
  COOKIE_LIST,
  COOKIE_SERVICE_NAME_LIST,
} from '@hivebrite/design-system/CookieBanner';

import { COOKIE_TYPES } from 'hb-react/backoffice/apps/Cookies/constants';
import filterListByPropertyAndValues from 'hb-react/shared/utils/filter/filterListByPropertyAndValues';

const byType = (customCookies) => (type) =>
  customCookies.filter(({ cookie_type: cookieType }) => cookieType === type);

const toServiceNameCookie = ({ name, version }) => ({
  name: `${name}_${version}`,
  accepted: true,
});

const getCookies = ({
  env,
  paymentMethod,
  hasPaymentAccount,
  amplitudeIsEnabled,
  linkedInIsEnabled = true,
  twitterIsEnabled = true,
  facebookIsEnabled = true,
  flagActivateFrontMonitoringDatadog = false,
  flagUeNewOutdatedBrowserDetection = false,
  flagAxpJimo = false,
  hasGoogleAnalyticsTracking = true,
  customCookies = [],
}) => {
  const values = [];

  if (hasPaymentAccount === false) {
    values.push('Paypal', 'Stripe', 'Braintree');
  }
  if (paymentMethod === 'Stripe' && hasPaymentAccount) {
    values.push('Paypal', 'Braintree');
  }
  if (paymentMethod === 'Paypal' && hasPaymentAccount) {
    values.push('Stripe', 'Braintree');
  }
  if (paymentMethod === 'Braintree' && hasPaymentAccount) {
    values.push('Stripe', 'Paypal');
  }
  if (amplitudeIsEnabled === false) {
    values.push('Amplitude (Trackers)');
  }
  if (linkedInIsEnabled === false) {
    values.push('LinkedIn');
  }
  if (twitterIsEnabled === false) {
    values.push('Twitter');
  }
  if (facebookIsEnabled === false) {
    values.push('Facebook');
  }
  if (hasGoogleAnalyticsTracking === false) {
    values.push('Google analytics');
  }
  if (flagActivateFrontMonitoringDatadog === false) {
    values.push('Datadog');
  }
  // Also remove this service name inside front-monorepo cookieList when we remove this flag
  if (flagUeNewOutdatedBrowserDetection === false) {
    values.push('Hivebrite (flagUeNewOutdatedBrowserDetection)');
  }
  if (flagAxpJimo === false) {
    values.push('Jimo');
  }

  const getCookiesByType = byType(customCookies);

  const customFunctional = getCookiesByType(COOKIE_TYPES.FUNCTIONAL);
  const customTracking = getCookiesByType(COOKIE_TYPES.TRACKING);
  const customRequired = getCookiesByType(COOKIE_TYPES.REQUIRED);

  const cookieListTemp = {
    functional: [
      ...filterListByPropertyAndValues(
        COOKIE_LIST.functional,
        'service_name',
        values,
      ),
      ...customFunctional,
    ],
    required: [
      ...filterListByPropertyAndValues(
        COOKIE_LIST.required,
        'service_name',
        values,
      ),
      ...customRequired,
    ],
    tracking: [
      ...filterListByPropertyAndValues(
        COOKIE_LIST.tracking,
        'service_name',
        values,
      ),
      ...customTracking,
    ],
  };

  const cookieServiceNameListTemp = {
    functional: [
      ...filterListByPropertyAndValues(
        COOKIE_SERVICE_NAME_LIST.functional,
        'name',
        values,
      ),
      ...customFunctional.map(toServiceNameCookie),
    ],
    required: [
      ...filterListByPropertyAndValues(
        COOKIE_SERVICE_NAME_LIST.required,
        'name',
        values,
      ),
      ...customRequired.map(toServiceNameCookie),
    ],
    tracking: [
      ...filterListByPropertyAndValues(
        COOKIE_SERVICE_NAME_LIST.tracking,
        'name',
        values,
      ),
      ...customTracking.map(toServiceNameCookie),
    ],
  };

  switch (env) {
    case 'po':
    case 'fo':
      return {
        cookieList: cookieListTemp,
        cookieServiceNameList: cookieServiceNameListTemp,
      };
    case 'bo':
      return {
        cookieServiceNameList: {
          ...BO_COOKIE_SERVICE_NAME_LIST,
          required: [
            ...filterListByPropertyAndValues(
              BO_COOKIE_SERVICE_NAME_LIST.required,
              'name',
              values,
            ),
            ...customRequired.map(toServiceNameCookie),
          ],
        },

        cookieList: {
          ...BO_COOKIE_LIST,
          required: filterListByPropertyAndValues(
            BO_COOKIE_LIST.required,
            'service_name',
            values,
          ),
        },
      };
    default:
      return null;
  }
};

export default getCookies;
